import { Toaster } from "react-hot-toast";

export const AppToaster = () => (
  <Toaster
    toasterId="default"
    position="top-center"
    containerClassName="toast-container"
    toastOptions={{ duration: 6000, className: "toast-content" }}
  />
);
